<app-tree-table
  [(focusYear)]="focusYear"
  (focusYearChange)="focusYearChange($event)"
  [actionColumnWidth]="0"
  [columns]="columns"
  [editable]="true"
  [firstColumnFrozen]="true"
  [footer]="true"
  [hasFocusYear]="true"
  [headerGroups]="headerGroups"
  [isCreateAllowed]="false"
  [newHeaderGroupMode]="true"
  [showFrozenColumnSelection]="false">
  <ng-template
    (onClick)="organisationalUnitOverlayPanel.toggle($event)"
    appToolbarButton
    icon="fal fa-sitemap"
    labelKey="ASSIGNMENT.ORGANISATIONAL_UNIT_FILTER"></ng-template>

  <ng-template
    (onClick)="importFromPreviousYear()"
    appToolbarButton
    icon="fal fa-history"
    labelKey="TIME_BUDGETS.IMPORT_FROM_PREVIOUS_YEAR"></ng-template>

  <ng-template
    (onClick)="csvExport()"
    appToolbarButton
    icon="fal fa-file-csv"
    labelKey="TIME_BUDGETS.OLD_CSV_EXPORT"></ng-template>
</app-tree-table>

<p-popover
  (onHide)="load()"
  [hideTransitionOptions]="'0ms'"
  [showTransitionOptions]="'0ms'"
  [style]="{ width: '500px' }"
  #organisationalUnitOverlayPanel>
  <div class="grid grid-cols-12">
    <div class="col-span-12">
      <p-button
        (onClick)="visibleColumns = flattenTree(columnTree)"
        [label]="'ACTIONS.SELECT_ALL' | translate"
        icon="fal fa-check-square"
        styleClass="p-button-text"></p-button>
      <p-button
        (onClick)="visibleColumns = []"
        [label]="'ACTIONS.DESELECT_ALL' | translate"
        icon="fal fa-square"
        styleClass="p-button-text"></p-button>
      <p-tree
        (selectionChange)="visibleColumns = $any($event)"
        [propagateSelectionDown]="false"
        [selection]="visibleColumns"
        [style]="{ width: '100%' }"
        [value]="columnTree ?? []"
        scrollHeight="calc(100vh - 200px)"
        selectionMode="checkbox"></p-tree>
    </div>

    @if (visibleColumns.length > maxColumns) {
      <div class="col-span-12">
        <p-message [text]="'ASSIGNMENT.TOO_MANY_COLUMNS' | translate" severity="warn"></p-message>
      </div>
    }

    <div class="col-span-12">
      <p-button
        (onClick)="organisationalUnitOverlayPanel.hide()"
        [label]="'ACTIONS.OK' | translate"
        icon="fal fa-check"></p-button>
    </div>
  </div>
</p-popover>
